import { PueCertificatesApi } from '../../src/_api/ilerna-StudentAccount/src'
import { asyncLazySingleton } from '../_common/common';

export const pueCertificatesApi = new asyncLazySingleton(async () => new PueCertificatesApi())